import React, { useContext, useEffect, useState, useRef } from "react";
import config, { getParameterByName, merchantCode } from "../util";
import { Store } from "../Store";
// import './OrderScreenTheme.css';
// import './OrderScreenTheme.css';
import Chip from "@mui/material/Chip";
import axios from "axios";
import Slider from "react-slick";
import SearchBar from '../components/SearchBar'; 
import { addToOrder, clearOrder, removeFromOrder } from "../actions";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  ClickAwayListener,
  Slide,
  MenuList,
  MenuItem,
  Zoom,
  Popper,
  Grow,
  Paper,
    Fab,
  TextField,
  Typography,
   Tabs,
  Tab
} from "@material-ui/core";
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import RedeemIcon from '@mui/icons-material/Redeem';
import { useLocation, useHistory } from 'react-router-dom';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { Alert } from "@material-ui/lab";
import { useStyles } from "../styles";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ReviewScreen from "./ReviewScreen";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import Categories from "./Categories"
import onlineLogo from '../assets/image/matari-gold-logo.svg';
//import bgImg from '../assets/image/bg.jpg';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@material-ui/icons/Search';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';


export default function OrderScreen(props) {
  const styles = useStyles();
  const { state, dispatch } = useContext(Store);
  const { orderItems, itemsCount, totalPrice, taxPrice, orderType } =
    state.order;
     const history = useHistory();
  const {promos} = state.order;
  let selectedCurrency = state.selectedCurrency;
  const [totalProducts, setTotalProducts] = useState([]);
  const [totalAddons, setTotalAddons] = useState([]);
  const [itemGroup, setItemGrorp] = useState([]);
  const [filterItmGrp, setFilterItmGrp] = useState([]);
  const [itemGrpId, setItemGrpId] = useState("");
  const [addonsGroup, setAddonsGroup] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [tabSel, setTabSel] = React.useState(0);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [errorProducts, setErrorProducts] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [addons, setAddons] = useState([]);
  const [subPro, setSubPro] = useState([]);
  const [selectedCat, setSelectedCat] = useState("");
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const [categoryProductMap, setCategoryProductMap] = useState({});
  const [currAdd, setCurrAdd]  = useState("");
  const baseURL = config.baseURL;
  const anchorRef = React.useRef(null);
  let { setting } = state.userSetting ;
  let { userInfo } = state.userData;
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
 const customersInfo =sessionStorage.getItem("customerInfo")?JSON.parse(sessionStorage.getItem("customerInfo")):"";
  if(!setting){
    setting=JSON.parse(localStorage.getItem("userInfo"));
  }
  selectedCurrency = selectedCurrency?selectedCurrency:"usd";
  let currSymbol= {
    'usd':"$",
    'inr':"₹"
  }
  console.log(setting);

  const [product, setProduct] = useState([]);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const [showPickupAddress, setShowPickupAddress] = useState(false);

  const searchIconRef = useRef(null);
  // const arrowRef = useRef(null);
  // // Responsive popover width
  // const [popoverWidth, setPopoverWidth] = useState(340);

  const closeHandler = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    console.log("---getting adons---");

    if (!totalAddons.length) {
      axios
        .get(
          `${baseURL}/api/clover/product-modifiers?merchantCode=${merchantCode}`
        )
        .then((res) => {
          console.log(res);
          let adon = res.data.map((ad) => {
            ad["quantity"] = 0;
            return ad;
          });

          setTotalAddons(adon);
        });
    }
    document.getElementById("footer").style.display = "none";
  }, []);
  
   const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }
  const goto =(subpath) =>{
      history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }
  const getCurrentAddrss = () => {
     let lat = getParameterByName('lat') && getParameterByName('lat')!='null'?getParameterByName('lat'):15.4618532824293 ;
     let long = getParameterByName('long') && getParameterByName('long') != 'null'?getParameterByName('long'):74.9999533120186;
     console.log(lat);
     if(lat && long){
     axios
      .get(`https://dev.virtualearth.net/REST/v1/Locations/${lat},${long}?o=json&key=ArW_TkF5xKfdKeIe4Ac-IQaAI7Mm3FLkRbPaj0g5EqEvF01MqV5JMR-ABy2BxrPd`)
      .then((res) => {
        console.log(res);
        if(res.data.resourceSets[0]?.resources[0].name ){
        setCurrAdd(res.data.resourceSets[0].resources[0].name );
        localStorage.setItem('address', res.data.resourceSets[0].resources[0].name);
        }
      })
       .catch((error) => {
        console.log(error);
       })

       }
  }
 
  useEffect(() => {
    //enable for only delivery
    //getCurrentAddrss();

    axios
      .get(`${baseURL}/api/clover/products?merchantCode=${merchantCode}`)
      .then((res) => {
        const products = res.data;
        console.log(products);
        setTotalProducts(products);

        // Create mapping of category IDs to products
        const map = {};
        const categorySet = new Set();

        products.forEach((product,i) => {
          if (
            product.categories &&
            product.categories.elements &&
            product.categories.elements.length > 0
          ) {
            if(!selectedCat && i==1){
              setSelectedCat(product.categories?.elements[0]?.id||"");
            }
            const categoryId = product.categories.elements[0].id;
            const categoryName = product.categories.elements[0].name;

            if (!map[categoryId]) {
              map[categoryId] = {
                name: categoryName,
                products: [],
              };
            }
            map[categoryId].products.push(product);
            categorySet.add(categoryId);
          }
        });
        console.log(map)
        setCategoryProductMap(map);
        setLoadingProducts(false);
        //document.getElementById("order-root").style.backgroundImage='url('+bgImg+')';
      })
      .catch((error) => {
        setLoadingProducts(false);
        setErrorProducts("Failed to load products");
      });
  }, [baseURL, merchantCode]);

  const categoryClickHandler = (cat) => {
    console.log(cat);
    setSelectedCat(cat);
    setIsCategoryMenuOpen(false);
  };

  const productClickHandler = (p) => {
    console.log(p);

    console.log(orderItems);
    let existingOrder = orderItems.filter((o) => o.id === p.id);
    console.log(existingOrder);
    setProduct(p);

    if (existingOrder.length) {
      setQuantity(existingOrder[0].quantity);
    } else {
      setQuantity(1);
    }

    if (p.modifierGroups) {
      let adGrp = p.modifierGroups.elements.length
        ? p.modifierGroups.elements
        : [];
      console.log(adGrp);
      setAddonsGroup(adGrp);
      let adItems = [];
      adGrp.filter((it) => {
        totalAddons.filter((ad) => {
          if (ad.modifierGroup.id === it.id) {
            adItems.push(ad);
          }
        });
      });
      console.log(adItems);
      setAddons(adItems);
    } else if (p.add_ons) {
      console.log(p.add_ons.split(","));
      let adongrp = [];
      p.add_ons.split(",").map((i) => {
        addonsGroup.map((ad) => {
          if (i === ad.id) {
            adongrp.push(ad);
          }
        });
      });
      let adItms = [];
      adongrp.map((ag) => {
        totalProducts.map((pro) => {
          if (ag.id === pro.category) {
            console.log(pro);
            pro["quantity"] = 0;
            adItms.push(pro);
          }
        });
      });
      setAddons(adItms);
    }

    setIsOpen(true);
  };
  console.log(addons);
  const handleAddonClick = (addon) => {
    setSelectedAddons((prev) => {
      if (prev.includes(addon.id)) {
        return prev.filter((id) => id !== addon.id);
      } else {
        return [...prev, addon.id];
      }
    });
  };

  const addToOrderHandler = () => {
    product["sub_pro"] = JSON.stringify(subPro.map((li) => li));
    product["addons"] = selectedAddons.map((id) =>
      addons.find((addon) => addon.id === id)
    );

    addToOrder(dispatch, { ...product, quantity });

    console.log(product);
    let adons = totalAddons.map((ad) => {
      ad.quantity = 0;
      return ad;
    });

    setTotalAddons(adons);
    setAddons([]);
    setIsOpen(false);
    setQuantity(1);
    setSubPro([]);
    setSelectedAddons([]);
  };

  const cancelOrRemoveFromOrder = () => {
    // let adons = totalAddons.map((ad) => {
    //   ad.quantity = 0;
    //   return ad;
    // });

    // setTotalAddons(adons);
    // setAddons([]);
    // setSubPro([]);
    // removeFromOrder(dispatch, product);
    setIsOpen(false);
  };

  const previewOrderHandler = () => {
    props.history.push(`/select-payment?` + window.location.href.split("?")[1]);
  };
 
  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "./images/blank.png";
  };

  const itemGroupHandle = (itmgrpId) => {
    setItemGrpId(itmgrpId);
  };

  let ItemsWithGrp = filterItmGrp.length ? filterItmGrp : totalProducts;

  const handleCartClick = () => {
    history.push('/cart?' + window.location.href.split('?')[1]);
  };

  const handleFavoritesClick = () => {
    setTabSel(2);
    goto('favourites');
  };

  return (
    <Box
      className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor }} 
      id={"order-root"}
    >
    <div style={{height:"50px",width:"100%",display:"flex",justifyContent:"space-between",padding:"5px", fontFamily:setting.themeSecondaryFontFam}}>
      <div style={{width:"120px",marginLeft:"5px", color:"#fff", marginTop:"0px", display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
      <span style={{marginLeft: '10px',color:"#fff"}}>{`Welcome! ${customersInfo.customer.firstName}`}</span>
      
    </div>
    <div style={{paddingTop:"1px",maxWidth:"150px", color: "#FFF",  fontWeight: 500, fontFamily:setting.themeSecondaryFontFam, marginRight:"10px"}}>
      
      <FmdGoodOutlinedIcon
       style={{ cursor: 'pointer', fontSize: 29, marginRight:"10px" }} 
        onClick={(e) => {
          setSearchAnchorEl(e.currentTarget);
          //setShowSearchInput(true);
          setShowPickupAddress(true);
        }} 
      />

      <SearchIcon 
        style={{ cursor: 'pointer', fontSize: 32, paddingTop:'4px' }} 
        onClick={(e) => {
          setSearchAnchorEl(e.currentTarget);
          setShowSearchInput(true);
        }} 
        ref={searchIconRef}
      />
      
    </div>
  
    </div>
      <div className={styles.promo} style={{padding:"0px 10px", maxHeight:"200px", overflow:"hidden"}}>
        <Slider {...settings} autoplay={true} autoplaySpeed={2000}>
          <div >
            <img style={{borderRadius:"10px"}} src="./images/banner-1.JPG" className={styles.promoImg} />
          </div>
          <div >
            <img style={{borderRadius:"10px"}} src="./images/banner-2.JPG" className={styles.promoImg} />
          </div>
          <div >
            <img style={{borderRadius:"10px"}} src="./images/banner-3.JPG" className={styles.promoImg} />
          </div>
          <div >
            <img style={{borderRadius:"10px"}} src="./images/banner-4.JPG" className={styles.promoImg} />
          </div>
        </Slider>
      </div>
     {false && <div id="search-hold" style={{margin:"10px",textAlign:"center",width:"100%",display:"flex",
    justifyContent:"center",position:"absolute",top:"60px"}}>
      <SearchBar style={{maxWidth:"300px"}}
                  searchQuery={searchQuery} 
                  onSearchChange={setSearchQuery}
                  placeholder={"Search menu items..."}
                  
                /></div>}
       <Categories 
        catPros={categoryProductMap} 
        selectedCat={selectedCat}
        imageOnErrorHandler={imageOnErrorHandler}
        categoryClickHandler={categoryClickHandler}
        setting={setting}
        />
      <SlidingPane
        className="slide-pane-review"
        overlayClassName="dark-overlay"
        isOpen={isPaneOpen}
        onRequestClose={() => {
          setIsPaneOpen(false);
        }}
        title=<Typography
            gutterBottom
            variant="h5"
            component="h5"
            id="title1"
            style={
              {
                color: setting.themeColor,
                fontWeight:"800",
                padding:"0px"
              }
            }
 
          >
            Cart
          </Typography>
        subtitle="Review your Cart items"
      >

        <div >
          <ReviewScreen setIsPaneOpen={setIsPaneOpen} />
        </div>
      </SlidingPane>


      {isOpen && (
  <Box
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: `#201101ed`,  // <-- your image
      backgroundSize: "cover",
      backgroundPosition: "center",
      zIndex: 1298, // lower than MUI dialog (default zIndex is 1300)
    }}
  />
)}
      <Dialog
         open={isOpen}
  onClose={closeHandler}
  fullWidth
  maxWidth="sm"
  BackdropProps={{
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    }
  }}
        PaperProps={{
  style: {
    backgroundColor:setting.themeColor,
    color: "#FFFFFF",
    padding: "0px",
    borderRadius: "5px",
    fontFamily: setting.themePrimaryFontFam
   
  }
}}

      >
        <DialogTitle >
             <ArrowBackIosNewIcon style={{position:"absolute",left: "10px",top:"9px",color:setting.themeTxtColor, }} onClick={cancelOrRemoveFromOrder}/><span style={{fontFamily: setting.themePrimaryFontFam,fontSize:"1.2em"}}>   Add {product.name}</span>
        </DialogTitle>
        <Box className="customize-box" style={{ display: "flex", flexDirection: "row" }}>
          <Box style={{ flex: "0 0 40%" }}>
            <Card
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                
              }}
            >
              <CardMedia
                component="img"
                alt={product.name}
                onError={imageOnErrorHandler}
                image={`https://cloverstatic.com/menu-assets/items/${product.id}.jpeg`}
                style={{ width: "100%", height: "auto", maxHeight: "500px", borderRadius:"5px" }}
              />
            </Card>
          </Box>
          <Box style={{ flex: "0 0 60%", overflowY: "auto" }}>
            <Box style={{ padding: "10px" }}>
              <div style={{display:'flex',justifyContent:"space-between"}}>
              <Typography
                variant="h5"
                style={{  color: setting.themeTxtColor }}
              >
                <span style={{fontFamily: setting.themePrimaryFontFam}}>{product.name}</span>
              </Typography>
              <Typography
                variant="h6"
                style={{color: '#fff',minWidth:'80px',marginLeft:'5px' }}
              >
                {currSymbol[selectedCurrency]} {product.price/100}
              </Typography>
              </div>
              <Box className={[styles.countRow, styles.center, styles.countHolder]} style={{ marginTop: "10px" }}>
                <Button
                  id="minus_btn"
                  variant="contained"
                  disabled={quantity === 1}
                  onClick={(e) => quantity > 1 && setQuantity(quantity - 1)}
                  style={{ marginRight: "10px", backgroundColor: setting.themeTxtColor, color: setting.themeColor }}
                >
                  <RemoveIcon />
                </Button>
                <TextField
                  InputProps={{className:'countinput', color:'#ccc', padding:"5px" }}
                  type="number"
                  style={{color:'#ccc', padding:"15px"}}
                  variant="filled"
                  min={1}
                  value={quantity}
                  color ={setting.themeTxtColor}
                />
                <Button
                  id="plus_btn"
                  variant="contained"
                  onClick={(e) => setQuantity(quantity + 1)}
                  style={{ marginLeft: "10px",  backgroundColor: setting.themeTxtColor, color: setting.themeColor }} 
                >
                  <AddIcon sx={{ fontSize: "1px" }} />
                </Button>
              </Box>
            </Box>
            <Box >
              <h4 style={{textAlign:"center",color:"#fff",marginBottom:"30px", fontFamily: setting.themePrimaryFontFam}}>{'Choose Addons & variant'}</h4>
              {addonsGroup.length
                ? addonsGroup.map((addGroup) => (
                  <Box key={addGroup.id}>
                   <h4 style={{ color:'#ccc',marginTop:"10px",letterSpacing:1.2,  fontFamily: setting.themePrimaryFontFam }}>
                      {addGroup.name.toUpperCase()}
                    </h4>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap"
                      }}
                    >
                      {addons
                        .filter((addon) =>
                          addGroup.modifierIds.split(",").includes(addon.id)
                        )
                        .map((itm) => (
                          <Card
                            className={`addon-card ${selectedAddons.includes(itm.id)
                              ? "selected"
                              : ""
                              }`}
                            key={itm.id}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              height: "auto",
                              minHeight:"50px",
                              width: "auto",
                              minWidth:"100px",
                              margin: "10px",
                              border: "0.1em solid "+setting.themeTxtColor, 
                              justifyContent: "center",
                              alignItems: "center",
                              fontWeight:"600",
                              padding:"4px 10px",
                              backgroundColor: selectedAddons.includes(itm.id)
                                ? setting.themeTxtColor
                                : setting.themeColor,

                              cursor: "pointer",

                              
                            }}
                            onClick={() => handleAddonClick(itm)}
                          >
                            <CardContent
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center"

                              }}
                            >
                              <span style={{fontFamily: setting.themeSecondaryFontFam,  color:  selectedAddons.includes(itm.id)?setting.themeColor:setting.themeTxtColor,fontWeight:"600" }}>
                                <strong>{itm.name}</strong>
                              </span>
                              <span style={{ marginTop: "5px",  color: selectedAddons.includes(itm.id)?setting.themeColor:setting.themeTxtColor,fontSize:"1.1em" }}>
                                {currSymbol[selectedCurrency]} {itm.price/100}
                              </span>
                            </CardContent>
                          </Card>
                        ))}
                    </div>
                  </Box>
                ))
                : ""}
            </Box>
            <Box
              className={[styles.row, styles.around]}
              style={{ marginBottom: "5px" }}
            >
              <Button
                onClick={addToOrderHandler}
                variant="contained"
                size="large"
                style={{
                  backgroundColor: setting.themeTxtColor, // Updated primary color
                  color: setting.themeColor,
                  fontWeight:'700',
                  borderRadius:"8px",
                  padding: '10px 20px'
                }}
              >
                ADD TO CART
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
       {false && !isPaneOpen && <Zoom in={true}>
        <Fab 
          aria-label="categories"
          style={{ 
            position: 'fixed', 
            bottom:'30px', 
            right:'30px', 
            color: "#000000",
            backgroundColor: "#543A20", // Updated background color
            zIndex: 1000,
            boxShadow: '0 4px 14px rgba(0,0,0,0.25)'    
          }}
          onClick={() => setIsCategoryMenuOpen(true)}
          ref={anchorRef}
        >
          <RestaurantMenuIcon />
        </Fab>
      </Zoom>}
      <Popper open={isCategoryMenuOpen} anchorEl={anchorRef.current}  transition disablePortal style={{overflow:'auto',maxHeight:"400px",zIndex:"9999999999"}}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setIsCategoryMenuOpen(false)}>
                <MenuList autoFocusItem={isCategoryMenuOpen} id="menu-list-grow">
                  {Object.keys(categoryProductMap).map((category) => (
                    <MenuItem 
                      key={category} 
                      onClick={() => categoryClickHandler(category)}
                      style={{ display: 'flex', alignItems: 'center', backgroundColor:setting.themeTxtColor, color: "#FFFFFF" }} // Updated background color
                    >
                      {categoryProductMap[category].name}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <Grid container style={{height:"calc(100vh - 366px)"}}>
        {Object.keys(categoryProductMap).filter(catId => (searchQuery || catId == selectedCat)).map((categoryId) => {
          const { name, products } = categoryProductMap[categoryId];

          return (
            <React.Fragment key={categoryId}>
              <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 3, lg: 4 }}>
                {loadingProducts ? (
                  <CircularProgress />
                ) : errorProducts ? (
                  <Alert severity="error">{errorProducts}</Alert>
                ) : (
                  products.filter(p => p.name.toLowerCase().indexOf(searchQuery.toLowerCase()) != -1).map((it) => (
                    <React.Fragment key={it.id}>
                      <Slide direction="up" in={true} style={{textAlign:"center"}}>
                        <Grid item xs={6} lg={3} md={4} sm={6}>
                         <Card
  onClick={() =>
    productClickHandler(it)
  }
  style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "200px",
    border: "1px solid #CE9760",
    backgroundColor: setting.themeTxtColor,
    borderRadius: "8px",
    padding: "0px"
  }}
>
  <CardActionArea>
    <CardContent style={{ padding: "0" }}>
      <div style={{
        width: "100%",
        minHeight: "110px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "5px",
        borderRadius: "6px",
        overflow: "hidden",
        fontFamily: setting.themeSecondaryFontFam
      }}>
        <img
          src={`https://cloverstatic.com/menu-assets/items/${it.id}.jpeg`}
          onError={imageOnErrorHandler}
          alt={it.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain"
          }}
        />
      </div>
      <div style={{display:'flex',width:"100%",justifyContent:'space-between'}}>
      <Typography
        variant="body1"
        style={{
          textAlign:"left",
          fontWeight: 600,
          fontSize: "14px",
          color: setting.themeColor,
          maxWidth:"80%",
          marginBottom: "8px",
          fontFamily: setting.themeSecondaryFontFam
        }}
      >
        {it.name}
      </Typography>
      
        <Typography
          variant="body2"
          style={{
            fontWeight: 500,
            fontSize: "16px",
            fontWeight: 600,
            color:'#fff',
            fontFamily: setting.themeSecondaryFontFam
          }}
        >
          ${parseFloat(it.price/100).toFixed(2)}
        </Typography>
      
      </div>
      {false &&<div style={{
        alignSelf: "flex-end",
        border: "1px solid #aaa",
        borderRadius: "4px",
        padding: "2px 10px",
        width: "fit-content",
        cursor: "pointer",
        fontFamily: setting.themeSecondaryFontFam
      }}
        onClick={(e) => {
          e.stopPropagation();
          productClickHandler(it);
        }}
      >
        <AddIcon style={{ color: "#000" }} />
      </div>}
      <Typography
        variant="body1"
        style={{
          textAlign:"left",
          fontWeight: 300,
          fontSize: "10px",
          color: setting.themeColor,
        }}
      >
        {it.description||" + Add to cart"}
      </Typography>
    </CardContent>
  </CardActionArea>
</Card>
                        </Grid>
                      </Slide>
                    </React.Fragment>
                  ))
                )}
              </Grid>
            </React.Fragment>
          );
        })}
        
      </Grid>
  <Tabs 
        style={{
          backgroundColor: setting.themeTxtColor,
          borderTop: "2px solid " + setting.themeColor,
          padding:"10px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
      <Box
        style={{
          display: "none!important",
          position: "fixed",
          bottom: "0px",
          width: "96%",
        }}
        className="orderscreen_foot"
      >
        <Box>
          <Box
            className={[styles.bordered, styles.space]}
            style={{
              textAlign: "center",
              fontSize: "20px",
              lineHeight: "20px",
              display: "none",
              color: "#FFFFFF"
             
            }}
          >
            Tax: {currSymbol[selectedCurrency]}
            {taxPrice} | Total: {currSymbol[selectedCurrency]}
            {totalPrice} | Items: {itemsCount}
          </Box>
          <Box
            id="footer"
            style={{ display: "none!important" }}
            className={[styles.row, styles.around, styles.space]}
          >
            <Button
              onClick={() => {
                clearOrder(dispatch);
              }}
              variant="outlined"
              style={{ display: "none!important",  color: "#543A20", borderColor: "#CE9760" }} // Updated colors
              className={styles.largeButton}
              id="choose_clbtn"
            >
              Remove
            </Button>

            <Button
              onClick={previewOrderHandler}
              variant="contained"
              color="primary"
              style={{ display: "none!important",  backgroundColor: "#CE9760", color: "#FFFFFF" }} // Updated primary color
              disabled={orderItems.length === 0}
              className={styles.largeButton}
              id="nextbtn"
            >
              NEXT
            </Button>
          </Box>
        </Box>
         <Popper
        open={showSearchInput || showPickupAddress}
        anchorEl={searchAnchorEl}
        placement="bottom-end"
        transition
        style={{ zIndex: 99999 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'center top', transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
            <div style={{ position: 'relative', width: '100%', maxWidth: '98vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Paper style={{ 
                padding: '10px',
                background: setting.themeColor,
                border: `2px solid ${setting.themeTxtColor}`,
                borderRadius: '10px',
                margin: '8px 0 8px 0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transition: 'all 0.18s cubic-bezier(.4,2,.6,1)',
                minWidth: 0,
                height: '48px',
                width: '100%',
                maxWidth: 320,
                color : setting.themeTxtColor,
                fontFamily: setting.themeSecondaryFontFam
              }}>
                <ClickAwayListener onClickAway={() => {
                  setShowSearchInput(false);
                  setShowPickupAddress(false);
                  setSearchAnchorEl(null);
                }}>
                  {showPickupAddress?<div> 
                    <span style={{color:"#fff"}}>Your pickup address: </span> 
                   {setting.address|| 'Matari Cafe, Canton'}</div>:


                  <form style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 0, padding: 0 }} onSubmit={e => { e.preventDefault(); }}>
                    <input
                      autoFocus
                      type="text"
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      placeholder="Search menu items..."
                      style={{
                        width: '100%',
                        maxWidth: 250,

                        fontFamily: setting.themeSecondaryFontFam,
                        outline: 'none',
                        fontSize: '0.9em',
                        color: setting.themeTxtColor,
                        border: 'none',
                        height: '35px',
                        fontWeight: 400,
                        letterSpacing: '0.01em',
                        fontFamily: 'inherit',
                       margin:"10px",
                        backgroundColor: 'transparent',
                        transition: 'border 0.18s',
                        '::placeholder': {
                          color: '#aaa',
                          opacity: 1,
                        },
                      }}
                    />
                  </form>}
                </ClickAwayListener>
              </Paper>
            </div>
          </Grow>
        )}
      </Popper>
      </Box>
    </Box>
  );
}